module.exports = __webpack_public_path__ + "img/mira-document-scanner-mobile.7e58355c.svg";